import axios from "axios";
import {
  getBaseUrl,
  Microservice,
} from "@funded-here-interface/common/src/constant/baseUrl";
import { getApiResponseErrorMsg } from "@funded-here-interface/common/src/Utils/apiHelper";

interface GetMembershipAgreementUrlRequest {
  token: string;
  redirectUrl: string;
  webDomain: string;
  directCreateDocusign?: boolean;
}

const getMembershipAgreementUrl = async ({
  token,
  redirectUrl,
  webDomain,
  directCreateDocusign = false,
}: GetMembershipAgreementUrlRequest) => {
  try {
    const response = await axios.post(
      `${getBaseUrl(Microservice.TRADE_DIRECTORY)}/trade-directory/agreement/membership-agreement-url`,
      {
        redirectUrl,
        webDomain,
        directCreateDocusign,
      },
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        withCredentials: true,
      },
    );
    return response.data;
  } catch (e) {
    const message = getApiResponseErrorMsg(e);
    throw new Error(message);
  }
};

export default getMembershipAgreementUrl;
